import { render, staticRenderFns } from "./SimpleQuantityWidget.vue?vue&type=template&id=5235657d&scoped=true&"
import script from "./SimpleQuantityWidget.vue?vue&type=script&lang=js&"
export * from "./SimpleQuantityWidget.vue?vue&type=script&lang=js&"
import style0 from "./SimpleQuantityWidget.vue?vue&type=style&index=0&id=5235657d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235657d",
  null
  
)

export default component.exports